<template>
<div style="position:relative;">
    <div class="pic-wrapper" :style="{height:height+'px'}" v-if="showCover">
        <div class="pic-left">
            <img class="wrapper-img" v-lazy="leftSrc" v-if="leftSrc"/>
            <div class="cover"></div>
        </div>
        <div class="pic-right">
            <img class="wrapper-img" v-lazy="rightSrc" v-if="rightSrc"/>
            <div class="cover"></div>
        </div>
    </div>
    <mt-swipe :auto="auto" class="banner" v-if="list" ref="swipeWrapper" :style="{height:height+'px'}" @change="handleChange">
        <mt-swipe-item v-for="item in list" v-bind:key="item.id">
            <a :href="item.link" v-if="item.link">
                <img v-lazy="item.imageUrl" :style="{height:height+'px'}" />
            </a>
            <img v-lazy="item.imageUrl" v-else :style="{height:height+'px'}" />
        </mt-swipe-item>
    </mt-swipe>
    <div class="button-wrapper" v-if="showBtn">
        <a class="prev-button flex-item" @click="prev"><img src="@/../static/icon_previous.png"/></a>
        <a class="next-button flex-item" @click="next"><img src="@/../static/icon_next.png"/></a>
    </div>
</div>
</template>

<script>

import { Swipe, SwipeItem } from 'mint-ui'

export default {
    name: 'banner',
    components: {
        "mt-swipe": Swipe, 
        "mt-swipe-item": SwipeItem
    },
    data(){
        return {
            leftSrc:'',
            rightSrc:''
        }
    },
    methods:{
            prev: function () {
                this.$refs.swipeWrapper.clearTimer()
                 let index = this.$refs.swipeWrapper.index;
                 this.$refs.swipeWrapper.prev();
                 index++;
                 this.$refs.swipeWrapper._data.index = index;

                 this.$refs.swipeWrapper.initTimer();
            },
            next: function () {
                this.$refs.swipeWrapper.clearTimer()
                 let index = this.$refs.swipeWrapper.index;
                 this.$refs.swipeWrapper.next();
                 index++;
                 this.$refs.swipeWrapper._data.index = index;

                 this.$refs.swipeWrapper.initTimer();
            },
            handleChange: function(i){
                let index = this.$refs.swipeWrapper.index;
                console.log('handleChange:' + index)

                if(this.list.length == 0){
                    return;
                }
                if(index == 0){
                    this.leftSrc = this.list[this.list.length-1].imageUrl;
                }else{
                    this.leftSrc = this.list[index-1].imageUrl;
                }

                if(index == this.list.length-1){
                    this.rightSrc = this.list[0].imageUrl;
                }else{
                    this.rightSrc = this.list[index+1].imageUrl;
                }

            }
    },
    watch:{
        list:function(newVal, oldValue) {
            if(newVal != oldValue && this.showCover){
                this.handleChange(0);
            }
        }
    },
    props: {
        list: {
            type: Array,
            default: () => [],
        },
        auto: {
            type: Number,
            default: 5000
        },
        height:{
            type:Number,
            default: 840
        },
        showBtn:{
            type: Boolean,
            default:true
        },
        showCover:{
            type: Boolean,
            default:false
        }
    },
}
</script>

<style scoped>
.pic-wrapper{
    max-width: 1920px;
    min-width: 1200px;
    margin: 0 auto;
    position: absolute;
    width: 100%;
}
.pic-left,.pic-right{
    position: absolute;
    height: 100%;
}
.pic-left{
    left: 0;
}
.pic-right{
    right: 0;
}
.cover{
    background: black;
    opacity: 0.7;
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
}
.pic-left img{
    height: 100%;
}
.pic-right img{
    height: 100%;
}
.banner{
    width: 1200px;
    margin: 0 auto;
}
.banner div{
    height: auto;
    width: 1200px;
}
.banner img{
    width: 1200px;
}
.button-wrapper{
    position: absolute;
    top: 40%;
    width: 100%;
}
.prev-button{
    float:left;
    margin-left: 68px;
}
.next-button{
    float:right;
    margin-right: 68px;
}
.flex-item{
    cursor: pointer;
}
.flex-item img:hover{
    filter:contrast(50%);
}
</style>



// WEBPACK FOOTER //
// src/components/Banner.vue